// Medium - visual updates

export const yieldToMain = async options => {
  try {
    // Modern browsers with Scheduler API
    if ("scheduler" in window && window.scheduler) {
      if (window.scheduler.yield) {
        return window.scheduler.yield(options);
      }
      if (window.scheduler.postTask) {
        return window.scheduler.postTask(() => {}, options);
      }
    }

    // Fallback for non-supporting browsers
    return (options === null || options === void 0 ? void 0 : options.priority) === "user-blocking" ? Promise.resolve() : new Promise(resolve => setTimeout(resolve));
  } catch {
    return new Promise(resolve => setTimeout(resolve));
  }
};